<template>
  <link
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css"
    rel="stylesheet"
  />
  <div>
    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog
        as="div"
        class="relative z-50 xl:hidden"
        @close="sidebarOpen = false"
      >
        <TransitionChild
          as="template"
          enter="transition-opacity ease-linear duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 bg-gray-900/80" />
        </TransitionChild>

        <div class="fixed inset-0 flex">
          <TransitionChild
            as="template"
            enter="transition ease-in-out duration-300 transform"
            enter-from="-translate-x-full"
            enter-to="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leave-from="translate-x-0"
            leave-to="-translate-x-full"
          >
            <DialogPanel class="relative flex w-full max-w-xs flex-1">
              <!-- Sidebar component -->
              <div class="absolute right-0 top-0 flex w-16 justify-center pt-5">
                <button
                  type="button"
                  class="-m-2.5 p-2.5"
                  @click="sidebarOpen = false"
                >
                  <span class="sr-only">Close sidebar</span>
                  <XMarkIcon class="h-6 w-6 text-gray-900" aria-hidden="true" />
                </button>
              </div>
              <div
                class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 ring-1 ring-white/10"
              >
                <div class="flex h-16 shrink-0 items-center">
                  <router-link to="/">
                    <img src="/images/logo.svg" class="h-8 w-auto" />
                  </router-link>
                </div>
                <nav class="grid grid-cols-1 gap-y-3 h-full">
                  <ul class="space-y-0.5">
                    <li class="px-1 py-1.5">
                      <p
                        class="inline-block text-xs px-3 uppercase text-darkGray-4"
                      >
                        category.category
                      </p>
                      <ul class="flex flex-col py-1.5 gap-2">
                        <li class="px-3 py-1.5 rounded-md">
                          <button>
                            <div class="flex items-center justify-start">
                              <span
                                class="flex items-center justify-center flex-shrink-0 w-6 h-6"
                              >
                                <i class="text-xl fas"></i>
                              </span>
                              <span class="inline-block ml-3 text-sm truncate"
                                >item.name</span
                              >
                            </div>
                          </button>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul class="relative mt-auto py-1.5 space-y-2">
                    <li
                      class="flex items-center transition rounded-lg group shrink-0"
                    >
                      <p
                        class="ml-2 text-xs text-left sm:block truncate"
                        v-if="store.state.userStore.token !== null"
                      >
                        <strong class="block font-medium truncate"
                          >Förnamn Efternamn</strong
                        >
                      </p>
                      <div class="ml-auto flex items-center text-gray-600">
                        <button
                          @click="onChangePassword"
                          class="ml-2 hover:text-gray-900"
                          title="Byt Lösenord"
                        >
                          <i class="fas fa-key"></i>
                        </button>
                        <button
                          @click="onLogout"
                          class="ml-2 hover:text-gray-900"
                          title="Logga ut"
                        >
                          <i class="fas fa-sign-out-alt"></i>
                        </button>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div
      class="hidden xl:fixed xl:inset-y-0 xl:z-50 xl:flex xl:w-72 xl:flex-col"
    >
      <div
        class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 ring-1 ring-white/5"
      >
        <div class="flex h-16 shrink-0 items-center">
          <router-link to="/">
            <img src="/images/logo.svg" alt="logo" class="h-8 w-auto" />
          </router-link>
        </div>
        <nav class="flex flex-1 flex-col">
          <LinkButton
            style-type="cta"
            icon="plus"
            text="Skapa annons"
            :to="{
              name: 'formbuilderPicker',
            }"
            class="mb-4 -mt-1 w-full flex place-content-center"
          />
          <ul class="md:space-y-1">
            <li class="md:px-1 py-1.5">
              <p
                class="hidden lg:inline-block text-xs md:px-3 uppercase text-darkGray-4"
              >
                Välkommen!
              </p>

              <ul class="flex flex-col lg:py-1.5 gap-4 lg:gap-2">
                <li
                  :class="{ 'bg-blue-4': $route.name === 'RecruitHome' }"
                  class="md:px-3 py-1.5 rounded-md"
                >
                  <router-link
                    :to="{ name: 'RecruitHome' }"
                    :class="{
                      'text-blue-1': $route.name === 'RecruitHome',
                      'text-darkGray-3 hover:bg-blue-4':
                        $route.name !== 'RecruitHome',
                    }"
                  >
                    <div
                      class="flex items-center justify-center lg:justify-start"
                    >
                      <span
                        class="flex items-center justify-center flex-shrink-0 w-6 h-6"
                      >
                        <i class="text-2xl lg:text-xl fas fa-house"></i>
                      </span>
                      <span class="hidden lg:inline-block ml-3 text-sm">
                        Hem
                      </span>
                    </div>
                  </router-link>
                </li>
                <li
                  :class="{ 'bg-blue-4': $route.name === 'MyProfile' }"
                  class="md:px-3 py-1.5 rounded-md"
                >
                  <router-link
                    to="/minasidor"
                    :class="{
                      'text-blue-1': $route.name === 'MyProfile',
                      'text-darkGray-3 hover:bg-blue-4':
                        $route.name !== 'MyProfile',
                    }"
                  >
                    <div
                      class="flex items-center justify-center lg:justify-start"
                    >
                      <span
                        class="flex items-center justify-center flex-shrink-0 w-6 h-6"
                      >
                        <i class="text-2xl lg:text-xl fas fa-user"></i>
                      </span>
                      <span class="hidden lg:inline-block ml-3 text-sm">
                        Mina sidor
                      </span>
                    </div>
                  </router-link>
                </li>
                <li
                  :class="{ 'bg-blue-4': $route.name === 'RecruitChat' }"
                  class="md:px-3 py-1.5 rounded-md"
                >
                  <router-link
                    to="/recruit-chat"
                    :class="{
                      'text-blue-1': $route.name === 'RecruitChat',
                      'text-darkGray-3 hover:bg-blue-4':
                        $route.name !== 'RecruitChat',
                    }"
                  >
                    <div
                      class="flex items-center justify-center lg:justify-start"
                    >
                      <span
                        class="flex items-center justify-center flex-shrink-0 w-6 h-6"
                      >
                        <i class="text-2xl lg:text-xl fas fa-message"></i>
                      </span>
                      <span class="hidden lg:inline-block ml-3 text-sm">
                        Meddelanden
                      </span>
                    </div>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="xl:pl-72">
      <!-- Sticky search header -->
      <div
        class="sticky top-0 z-40 flex justify-end h-16 shrink-0 items-center gap-x-6 border-b border-white/5 bg-white px-4 shadow-sm sm:px-6 lg:px-8"
      >
        <div
          class="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 truncate sm:min-w-max"
        >
          <p class="truncate">Testmiljö - ej riktig data</p>
        </div>

        <div class="hidden xl:flex items-center justify-end gap-2">
          <NotificationsView />

          <Menu as="div" class="relative">
            <div>
              <MenuButton
                class="flex items-center transition rounded-lg group shrink-0"
                @click="toggleMenu"
              >
                <p class="ml-2 text-xs text-left sm:block">
                  <strong class="block font-medium truncate">
                    Förnamn Efternamn
                  </strong>
                </p>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-5 h-5 ml-2 text-darkGray-2 transition sm:block group-hover:text-darkGray-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </MenuButton>
            </div>

            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
              v-show="menuOpen"
            >
              <MenuItems
                class="absolute right-0 mt-3 w-56 origin-top-right divide-y text-gray-600 divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden"
              >
                <MenuItem>
                  <button
                    @click="onChangePassword"
                    class="group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6"
                  >
                    <div class="h-6 w-6 shrink-0" aria-hidden="true">
                      <i class="fas fa-key"></i>
                    </div>
                    <p>Byt lösenord</p>
                  </button>
                </MenuItem>
                <MenuItem>
                  <button
                    @click="onLogout"
                    class="group flex w-full items-center px-2 py-2 text-sm transition group gap-x-3 p-2 leading-6"
                  >
                    <div class="h-6 w-6 shrink-0" aria-hidden="true">
                      <i class="fas fa-sign-out-alt"></i>
                    </div>
                    <p>Logga ut</p>
                  </button>
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
        </div>
      </div>
      <main class="bg-blue-4 min-h-[calc(100vh-4rem)] p-4 md:p-6 lg:p-8">
        <slot />
        <vue-notification-list position="bottom-right"></vue-notification-list>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import { onMounted, ref, watch, onBeforeUnmount } from "vue";

import { useRouter } from "vue-router";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import "reflect-metadata";
import NotificationsView from "@/features/notifications/views/NotificationsView.vue";
const store = useStore();
const isLoaded = ref(false);
const router = useRouter();
const host = window.location.host;
const parts = host.split(".");
const subdomain = parts[0];
const isDevOrStaging =
  subdomain.includes("min-dev") || subdomain.includes("min-staging");

const onLogout = async () => {
  await store.dispatch("logout");
  router.push("/admin/login");
};

const onChangePassword = () => {
  router.push("/admin/change-password");
};

watch(
  () => router.currentRoute.value.name,
  () => {
    sidebarOpen.value = false;
  }
);

const sidebarOpen = ref(false);

onMounted(async () => {
  isLoaded.value = true;
});

const menuOpen = ref(false);
const menuContainer = ref(null);

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value;
};

const onClickOutsideMenu = (event: any) => {
  if (menuContainer.value && !menuContainer.value.contains(event.target)) {
    menuOpen.value = false;
  }
};

// Lyssna på klickhändelser på dokumentet
onMounted(() => {
  document.addEventListener("click", onClickOutsideMenu);
});

// Ta bort klickhändelselyssnare när komponenten avmonteras
onBeforeUnmount(() => {
  document.removeEventListener("click", onClickOutsideMenu);
});
</script>
